import { useEffect, useState } from 'preact/hooks';
import { getAnnouncementsData } from '../../data/announcements';
import type { Park, UUID } from '../../data/types';
import { AnnounceSheet } from './AnnounceSheet';

export function AnnounceHome() {
  const [parks, setParks] = useState<Park[]>([]);
  const [openFor, setOpenFor] = useState<{ id: UUID; name: string } | null>(
    null
  );

  useEffect(() => {
    const data = getAnnouncementsData();
    data
      .listParks()
      .then((ps) => setParks(ps))
      .catch(() => {
        // Fallback to an empty list (Memory provider still returns seed)
      });
  }, []);

  return (
    <section class="parks">
      <h2 class="sr-only">Parks</h2>
      <div class="park-list">
        {parks.map((p) => (
          <button
            key={p.id}
            class="park-button"
            type="button"
            aria-label={p.name}
            onClick={() => setOpenFor({ id: p.id, name: p.name })}
          >
            {p.name}
          </button>
        ))}
      </div>

      {openFor && (
        <AnnounceSheet
          open
          parkId={openFor.id}
          parkName={openFor.name}
          onClose={() => setOpenFor(null)}
        />
      )}
    </section>
  );
}

